/** Cofre do escritório: certificados digitais e senhas dos clientes, cifrados e com registro de acesso. */
import { createFileRoute } from '@tanstack/react-router';
import { Cofre } from '../telas/cofre/cofre';

export const Route = createFileRoute('/_app/cofre')({ component: Tela });

function Tela() {
  return (
    <>
      <div className="topbar"><div><h1>Cofre</h1><div className="sub">certificados digitais e senhas dos clientes — guardados cifrados; ver senha e baixar arquivo ficam registrados</div></div></div>
      <div className="conteudo"><Cofre /></div>
    </>
  );
}
